// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommandButton__container-a38eb0 {
  flex: 1 0 0;
  margin: 0 1px;
  cursor: pointer;
  min-width: 88px;
  padding: 8px 16px;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  border-radius: 4px;
  --color: var(--base-110);
  --color-hover: var(--base-110);
  --color-focus: var(--base-110);
  --color-active: var(--base-110);
  --color-disabled: var(--base-60);
  --background-color: var(--base-20);
  --background-color-hover: var(--base-30);
  --background-color-focus: var(--base-30);
  --background-color-active: var(--base-40);
  --background-color-disabled: var(--base-30);
  color: var(--color);
  background-color: var(--background-color);
}

.CommandButton__container-a38eb0:hover {
  color: var(--color-hover);
  background-color: var(--background-color-hover);
}

@supports (display: block) {
  .CommandButton__container-a38eb0:focus-visible {
    color: var(--color-focus);
    background-color: var(--background-color-focus);
  }
}
.CommandButton__container-a38eb0:active {
  color: var(--color-active);
  background-color: var(--background-color-active);
}

.CommandButton__container-a38eb0:disabled {
  color: var(--addition-60);
  background-color: var(--background-color-disabled);
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/ButtonsBubble/CommandButtons/CommandButton/CommandButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EAEA,iBAAA;EACA,wBAAA;EACA,0CAAA;EACA,kBAAA;EAEA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EAEA,kCAAA;EACA,wCAAA;EACA,wCAAA;EACA,yCAAA;EACA,2CAAA;EAEA,mBAAA;EACA,yCAAA;AAHF;;AAMA;EACE,yBAAA;EACA,+CAAA;AAHF;;AAMA;EACE;IACE,yBAAA;IACA,+CAAA;EAHF;AACF;AAMA;EACE,0BAAA;EACA,gDAAA;AAJF;;AAOA;EACE,yBAAA;EACA,kDAAA;EACA,eAAA;AAJF","sourcesContent":[".container {\n  flex: 1 0 0;\n  margin: 0 1px;\n  cursor: pointer;\n  min-width: 88px;\n\n  padding: 8px 16px;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  border-radius: 4px;\n\n  --color: var(--base-110);\n  --color-hover: var(--base-110);\n  --color-focus: var(--base-110);\n  --color-active: var(--base-110);\n  --color-disabled: var(--base-60);\n\n  --background-color: var(--base-20);\n  --background-color-hover: var(--base-30);\n  --background-color-focus: var(--base-30);\n  --background-color-active: var(--base-40);\n  --background-color-disabled: var(--base-30);\n\n  color: var(--color);\n  background-color: var(--background-color);\n}\n\n.container:hover {\n  color: var(--color-hover);\n  background-color: var(--background-color-hover);\n}\n\n@supports (display: block) {\n  .container:focus-visible {\n    color: var(--color-focus);\n    background-color: var(--background-color-focus);\n  }\n}\n\n.container:active {\n  color: var(--color-active);\n  background-color: var(--background-color-active);\n}\n\n.container:disabled {\n  color: var(--addition-60);\n  background-color: var(--background-color-disabled);\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CommandButton__container-a38eb0`
};
module.exports = ___CSS_LOADER_EXPORT___;
